<template>
  <div v-if="user_profile" id="SideMenu" class="section">
    <div style="margin-bottom: 1rem;">
      <h1 class="title is-4">WEALTH NAVI</h1>
      <h1 class="subtitle is-6">
        <b-tag v-if="user_profile.role === 'ceo'" type="is-primary">
          <b>{{ user_profile.role.toUpperCase() }} </b>
        </b-tag>
        <b-tag v-else-if="user_profile.role === 'admin'" type="is-danger">
          <b>{{ user_profile.role.toUpperCase() }} </b>
        </b-tag>
        <b-tag v-else-if="user_profile.role === 'manager'" type="is-warning">
          <b>{{ user_profile.role.toUpperCase() }} </b>
        </b-tag>
        <b-tag v-else type="is-info">
          <b>{{ user_profile.role.toUpperCase() }} </b>
        </b-tag>
      </h1>
    </div>
    <b-menu>
      <b-menu-list label="Menu">
        <b-menu-item
          icon="file-document"
          label="Fact Sheets"
          tag="router-link"
          :to="{ name: 'factsheet' }"
          :active="
            this.$route.name === 'factsheet' ||
              this.$route.name === 'factsheet-create' ||
              this.$route.name === 'factsheet-detal'
          "
        />
        <b-menu-item
          icon="scale-balance"
          label="Balance Sheet"
          tag="router-link"
          :to="{ name: 'balancesheet' }"
          :active="this.$route.name === 'balancesheet'"
        />
        <b-menu-item
          icon="pine-tree"
          label="Retirement"
          tag="router-link"
          :to="{ name: 'retirementsheet' }"
          :active="this.$route.name === 'retirementsheet'"
        />
        <b-menu-item
          icon="shape-plus"
          label="Templates"
          tag="router-link"
          :to="{ name: 'templates' }"
          :active="this.$route.name === 'templates'"
        />
        <b-menu-item
          v-if="
            user_profile.role === 'manager' ||
              user_profile.role === 'admin' ||
              user_profile.role === 'ceo'
          "
          icon="account-star"
          label="Client"
          tag="router-link"
          :to="{ name: 'client' }"
          :active="this.$route.name === 'client'"
        />
        <b-menu-item
          v-if="
            user_profile.role === 'manager' ||
              user_profile.role === 'admin' ||
              user_profile.role === 'ceo'
          "
          icon="account-tie"
          label="Users"
          tag="router-link"
          :to="{ name: 'user' }"
          :active="this.$route.name === 'user'"
        />
        <b-menu-item
          v-if="user_profile.role === 'admin' || user_profile.role === 'ceo'"
          icon="chess-rook"
          label="Business Unit"
          tag="router-link"
          :to="{ name: 'business-unit' }"
          :active="this.$route.name === 'business-unit'"
        />
      </b-menu-list>
      <b-menu-list label="Actions">
        <b-menu-item
          icon="cog"
          label="Setting"
          tag="router-link"
          :to="{ name: 'setting' }"
          :active="this.$route.name === 'setting'"
        />
        <b-menu-item
          icon="logout"
          label="Logout"
          @click.prevent="performLogout"
        />
      </b-menu-list>
    </b-menu>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import TokenManager from "@/utils/TokenManager";

export default {
  name: "SideMenu",
  computed: mapState(["user_profile"]),
  methods: {
    ...mapMutations({
      removeUserProfile: "REMOVE_USER_PROFILE"
    }),
    performLogout: function() {
      this.removeUserProfile();
      TokenManager.clearUserToken();

      this.$router.push({ name: "login" });
    }
  }
};
</script>

<style>
#SideMenu {
  text-align: left;
  height: 100vh;
  border: 1px solid #e8e8e8;
  border-top-width: 0;
  border-bottom-width: 0;
  border-left-width: 0;
  border-right-width: 1px;
}
</style>
